(function () {
  const widgets = [
    {
      selector: ".gw-wl-add-to-wishlist-placeholder",
      styles: `
        .gw-wl-add-to-wishlist-btn__inner span{
          font-size: 16px; !important;
          letter-spacing: .8px !important;
          font-family: owners-wide, sans-serif;
          font-weight: 500; !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding-top:3px !important;
        }
      `,
    },
    {
      selector: ".gw-rd-ways-to-earn-page-widget-placeholder",
      styles: `

        h2.gw-rd-page-widget-title{
          font-family: mono45-headline, sans-serif;
          font-size: 30px !important;
        }
        .gw-rd-page-widget-layout.svelte-1j89k9z{
          gap:25px !important;
        }
        .gw-rd-page-widget-card {
          background-color: #F7F6F5 !important;
          border: none !important;
          border-radius: 0 !important;
        }
        .gw-rd-page-widget-card__icon{
          background-color: #ffffff !important;
          margin-top:20px !important;
        }
        h2.gw-layout-text{
          text-transform: uppercase !important;
          font-size: 20px !important;
        }
        .gw-rd-page-widget-card__base-content.svelte-8gdoe8.svelte-8gdoe8{
          line-height:10px !important;
        }
        .gw-rd-page-widget-card__base-content .gw-rd-action-btn:nth-child(1){
          background:#000000 !important;
          color:#ffffff !important;
        }
        .gw-rd-page-widget-card__base-content .gw-rd-action-btn{
          text-transform: uppercase !important;;
          border: 1px solid #000 !important;;
          min-width: 117px !important;;
          border-radius: 0 !important;;
        }
        .gw-rd-action-btn .gw-layout-text{
          letter-spacing: 1.2px !important;
        }
      `,
    },
    {
      selector: ".gw-rd-ways-to-spend-page-widget-placeholder",
      styles: `
        .gw-rd-page-widget-card {
          background-color: #F7F6F5 !important;
          border: none !important;
          border-radius: 0 !important;
        }
        .gw-rd-page-widget-container{
          padding-top: 0 !important;
        }
        h2.gw-rd-page-widget-title{
          text-transform: uppercase !important;
          font-family: mono45-headline, sans-serif !important;
          font-size: 30px !important;
        }
        .gw-rd-page-widget-layout{
          gap:25px !important;
        }
        h2.gw-layout-text{
          text-transform: uppercase !important;
          font-size: 20px !important;
        }
        .gw-rd-list__item:nth-child(1) .gw-rd-page-widget-card__icon.svelte-8gdoe8 {
          background-color: rgba(254, 117, 40, 0.26) !important;
        }
        .gw-rd-list__item:nth-child(2) .gw-rd-page-widget-card__icon.svelte-8gdoe8 {
          background-color: rgba(151, 71, 255, 0.26) !important;
        }
        .gw-rd-list__item:nth-child(3) .gw-rd-page-widget-card__icon.svelte-8gdoe8 {
          background-color: rgba(168, 21, 89, 0.26) !important;
        }
        .gw-rd-page-widget-card__base-content.svelte-8gdoe8{
          line-height:10px !important;
        }
        .gw-rd-page-widget-card__icon{
          margin-top:20px !important;
        }
        .gw-rd-page-widget-card__base-content .gw-rd-action-btn:nth-child(1){
          background:#000000 !important;
          color:#ffffff !important;
        }
        .gw-rd-page-widget-card__base-content .gw-rd-action-btn{
          border-radius: 0 !important;
          text-transform: uppercase !important;
          border: 1px solid #000 !important;
          min-width: 117px !important;
          letter-spacing: 10% !important;
        }
        .gw-rd-action-btn .gw-layout-text{
          letter-spacing: 1.2px !important;
        }
      `,
    },
  ];

  const injectStyles = (host, styles) => {
    const shadow = host.shadowRoot;
    if (!shadow) return;

    const styleEl = document.createElement("style");
    styleEl.textContent = styles;
    shadow.appendChild(styleEl);
  };

  const observer = new MutationObserver((mutations, obs) => {
    widgets.forEach((widget) => {
      const host = document.querySelector(widget.selector);
      if (host && host.shadowRoot) {
        injectStyles(host, widget.styles);
      }
    });

    const allStyled = widgets.every((w) => {
      const el = document.querySelector(w.selector);
      return el && el.shadowRoot;
    });

    if (allStyled) {
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
